import React, {FunctionComponent} from "react";
import {Main} from './components/Main';


interface IUserConfigProps {
}


export const UserConfig: FunctionComponent<IUserConfigProps> = function (props) {
    return <Main/>
};
